;(function ($, window, document, undefined) {
	// var $body = $('body'),
	//     bodyWidth = $body.innerWidth(),
	//     $document = $(document);
	var $document = $(document);

	var pluginName = 'customScroll',
	    defaults = {
			rtl: false,
			axis: 'auto'
	    	// defaultPos: 50,
	    	// init: null,//fires after every item in collection is completed
	    	// fullInit: null,//fires after all collection is completed
	    	// initAnimFinished: null,//fires, when init animation with handle is finised
	    	// leftTorightCallback: null,
	    	// rightToLeftCallback: null,
	    	// synchronized: false
	    };

	function customScroll(element, options, fullCollection) {
		this.element = element;
		this.$element = $(element);
		this.options = $.extend(defaults, options);

		if (this.options.synchronized) {
			this.fullCollection = fullCollection;
		}

		if (this.$element.data('name')) {
			this._name = this.$element.data('name');//for debugging
		} else {
			this._name = pluginName;
		}

		return this.init();
	}

	customScroll.prototype.init = function() {
        var _this = this;
        this.$scrollOuter = this.$element.find('.scroll-outer'),
        this.$scrollInner = this.$element.find('.scroll-inner'),
        this.$fullContent = this.$scrollInner.children().first(),
        this.$scrollDraggerContainer = this.$element.find('.dragger-container'),
		this.$dragger = this.$scrollDraggerContainer.find('.dragger');
		this.$railway = this.$scrollDraggerContainer.find('.railway');
		
		this.prepareCustomScroll();

		// Initialize scroll event
		this.$scrollInner.on('scroll.custom-scroll', function() {
			_this.onScroll();
		});

		this.$scrollInner.trigger('scroll');//For FireFox (save scroll after refreshing)

		//Recalc of parameters on window resize
		$(window).on('custom.onresize', function() {
			_this.prepareCustomScroll();
		});

		this.$dragger.on('mousedown.custom-scroll touchstart.custom-scroll', function(e) {
			_this.onDrag(e);
		});

		this.$scrollDraggerContainer.on('click', function(e) {
			_this.onClick(e);
		});

		this.$element.addClass('initialized');
		this.initialized = true;

		if (this.options.init) {
			this.options.init.call(this.$element);
		}

		return this;
	}

	customScroll.prototype.prepareCustomScroll = function() {
		this.getMetrics();
		this.checkScroll();
		this.hideScrollbar();
	}
    
    customScroll.prototype.getMetrics = function() {
		
		if (this.options.axis === 'x') {
			this.scrollInnerWidth = this.$scrollInner.innerWidth();
			this.fullContentWidth = this.$scrollInner.get(0).scrollWidth;
			this.scrollOuterHeight = this.$scrollOuter.innerHeight();
			this.fullContentHeight = this.$fullContent.innerHeight();
			this.scrollLength = this.fullContentWidth - this.scrollInnerWidth;
			this.railwayLeft = this.$railway.offset().left;
		} else if (this.options.axis === 'y') {
			this.scrollInnerHeight = this.$scrollInner.innerHeight();
			this.fullContentHeight = this.$scrollInner.get(0).scrollHeight;
			this.scrollOuterWidth = this.$scrollOuter.innerWidth();
			this.fullContentWidth = this.$fullContent.innerWidth();
			this.scrollLength = this.fullContentHeight - this.scrollInnerHeight;
			this.railwayTop = this.$railway.offset().top;
		}

	}

	customScroll.prototype.checkScroll = function() {

		if (this.options.axis === 'x') {

			if (this.scrollInnerWidth !== this.fullContentWidth) {
				this.$element.addClass('is-draggable');
				this.isDraggableX = true;

				var draggerWidth = this.scrollInnerWidth * this.scrollInnerWidth / this.fullContentWidth;
				this.maxDraggerLeft = (1 - draggerWidth / this.scrollInnerWidth) * 100;
				this.$dragger.width(draggerWidth);
			} else {
				this.$element.removeClass('is-draggable');
				this.isDraggableX = false;
			}

		} else if (this.options.axis === 'y') {

			if (this.scrollInnerHeight !== this.fullContentHeight) {
				this.$element.addClass('is-draggable');
				this.isDraggableY = true;

				var draggerHeight = this.scrollInnerHeight * this.scrollInnerHeight / this.fullContentHeight;
				this.maxDraggerTop = (1 - draggerHeight / this.scrollInnerHeight) * 100;
				this.$dragger.height(draggerHeight);
			} else {
				this.$element.removeClass('is-draggable');
				this.isDraggableY = false;
			}

		}

	}

	customScroll.prototype.hideScrollbar = function(scrollAbove) {
		
		if (this.options.axis === 'x' && this.isDraggableX) {//console.log('hoho')
			
			if (this.scrollOuterHeight !== this.fullContentHeight) {//scrollbar is on the same level with content
				this.$scrollOuter.height(this.fullContentHeight);
				this.getMetrics();
			} else {//scrollbar above content
				
				if (!this.scrollOnSeparateLayer) {
					this.scrollOnSeparateLayer = true;
					this.$scrollInner.css('padding-bottom', '30px');
					this.getMetrics();
					this.hideScrollbar();
				}
				
			}

		} else if (this.options.axis === 'y' && this.isDraggableY) {

			if (this.initialized && !scrollAbove) {//so it's window resize and it's not switching between mobile and desktop modes
				this.$scrollInner.innerWidth('auto');
				this.$scrollInner.css('padding-right', '0');
				this.getMetrics();
				this.proceedScrollbarHiding()
			} else {//so it's window resize and it's switching between mobile and desktop modes or it's initializing
				this.proceedScrollbarHiding()
			}

		}

	}
	
	customScroll.prototype.proceedScrollbarHiding = function() {

		if (this.scrollOuterWidth !== this.fullContentWidth) {//scrollbar is on the same level with content
			this.$scrollInner.innerWidth(this.scrollOuterWidth + (this.scrollOuterWidth - this.fullContentWidth));
			this.getMetrics();
		} else {//scrollbar is on the layer above content
			this.$scrollInner.css('padding-right', '30px');
			this.getMetrics();
			this.hideScrollbar(true);
		}

	}

	customScroll.prototype.onScroll = function() {

		if (this.options.axis === 'x') {
			
			var scrollPos = this.$scrollInner.scrollLeft(),
				maxDraggerPos = this.maxDraggerLeft,
				fullContentMeasure = this.fullContentWidth,
				scrollInnerMeasure = this.scrollInnerWidth;
			
			if (scrollPos >= 0 && this.lastScrollPos >= 0 && this.options.rtl) {//for rtl; Chrome & FF has different scrollPos
				scrollPos = scrollPos - (fullContentMeasure - scrollInnerMeasure);
			}

		} else if (this.options.axis === 'y') {
			var scrollPos = this.$scrollInner.scrollTop(),
			    maxDraggerPos = this.maxDraggerTop,
				fullContentMeasure = this.fullContentHeight,
				scrollInnerMeasure = this.scrollInnerHeight;
		}

		var newDraggerPos = maxDraggerPos * scrollPos / (fullContentMeasure - scrollInnerMeasure);

		if (newDraggerPos < 0 && this.options.rtl) {//for rtl; Chrome & FF has different scrollPos
			newDraggerPos = -newDraggerPos;
		}

		this.setDraggerPos(newDraggerPos);

		if (Math.abs(newDraggerPos - maxDraggerPos) < 1) {//On some devices precision may lead to a mistake (that's why not newDraggerPos === maxDraggerPos)
			this.$element.addClass('scrolled-to-end scroll-began');
		} else {
			
			if (this.$element.hasClass('scrolled-to-end')) {
				this.$element.removeClass('scrolled-to-end');
			}
			
			if (scrollPos === 0) {
				
				if (this.$element.hasClass('scroll-began')) {
					this.$element.removeClass('scroll-began');
				}

			} else {
				this.$element.addClass('scroll-began');
			}

		}

		this.lastScrollPos = this.$scrollInner.scrollLeft();
		
	}

	customScroll.prototype.setDraggerPos = function(val) {
		
		if (this.options.axis === 'x') {

			if (this.options.rtl) {
				this.$dragger.css('right', val + '%');
			} else {
				this.$dragger.css('left', val + '%');
			}

		} else if (this.options.axis === 'y') {
			this.$dragger.css('top', val + '%');
		}

	}

	customScroll.prototype.onDrag = function(e) {
		this.isOnDrag = true;

		if (this.options.axis === 'x') {
			var startPos = this.getPos(e),
				startScroll = this.$scrollInner.scrollLeft(),
				fullContentMeasure = this.fullContentWidth,
				scrollInnerMeasure = this.scrollInnerWidth,
				_this = this;
		} else if (this.options.axis === 'y') {
			var startPos = this.getPos(e),
				startScroll = this.$scrollInner.scrollTop(),
				fullContentMeasure = this.fullContentHeight,
				scrollInnerMeasure = this.scrollInnerHeight,
				_this = this;
		}

		this.$element.addClass('is-dragged');
		this.$scrollDraggerContainer.on('mousemove.custom-scroll-temp touchmove.custom-scroll-temp', function(e) {
			var movePos = _this.getPos(e);
			_this.scrollTo(startScroll + (movePos - startPos) * fullContentMeasure / scrollInnerMeasure);
		});

		$document.on('mouseup.custom-scroll-temp touchend.custom-scroll-temp touchcancel.custom-scroll-temp', function() {
			_this.$scrollDraggerContainer.off('.custom-scroll-temp');
			$document.off('.custom-scroll-temp');
			_this.$element.removeClass('is-dragged');
		});
		
	}

	customScroll.prototype.getPos = function(e) {
		
		if (this.options.axis === 'x') {
			return (e.pageX) ? e.pageX : e.originalEvent.touches[0].pageX;
		} else if (this.options.axis === 'y') {
			return (e.pageY) ? e.pageY : e.originalEvent.touches[0].pageY;
		}

	}

	customScroll.prototype.scrollTo = function(val) {
		
		if (this.options.axis === 'x') {
			this.$scrollInner.scrollLeft(val);
		} else if (this.options.axis === 'y') {
			this.$scrollInner.scrollTop(val);
		}

	}

	customScroll.prototype.onClick = function(e) {
		
		if (!this.isOnDrag) {
			var _this = this,
				clickPos = this.getPos(e);
				
			if (this.options.axis === 'x') {
				var draggerPos = this.railwayLeft,
					maxDraggerPos = _this.maxDraggerLeft,
					scrollInnerMeasure = this.scrollInnerWidth;
			} else if (this.options.axis === 'y') {
				var draggerPos = this.railwayTop,
					maxDraggerPos = _this.maxDraggerTop,
					scrollInnerMeasure = this.scrollInnerHeight;
			}
			
			this.scrollTo(_this.scrollLength * (clickPos - draggerPos) / scrollInnerMeasure);
			this.setDraggerPos(maxDraggerPos * (clickPos - draggerPos) / scrollInnerMeasure);
		} else {
			this.isOnDrag = false;
		}

	}
	

	$.fn[pluginName] = function(options) {
		var fullCollection = this;
		this.each(function() {
			var $this = $(this);

			if (!$this.data('plugin_' + pluginName)) {
				$this.data('plugin_' + pluginName, new customScroll(this, options, fullCollection));
			}

		});

		if (options.fullInitCallback) {
			options.fullInitCallback();
		}

		return this;
	}

})(jQuery, window, document);